import { useEffect, useState } from "react";
import ReloadIcon from "@/assets/icons/reload.svg?react";
import { useTranslation } from "react-i18next";

const WAITING_TIME = 8000; // 8 seconds

const SplashScreen = () => {
  const [restart, setRestart] = useState(false);
  const { t } = useTranslation();
  // const videoRef2 = useRef(null);
  // const [playLoop, setPlayLoop] = useState(false);

  // const handleFirstVideoEnd = () => {
  //     setPlayLoop(true);
  // };

  useEffect(() => {
    setTimeout(() => {
      setRestart(true);
    }, WAITING_TIME);
  }, []);
  const reloadApp = () => {
    window.location.reload();
  };

  return (
    <div className="flex-center-between flex-col gap-4 overflow-hidden bg-dark h-safe-screen py-safe-bottom fixed top-0 w-full">
      <div className="w-8 h-8"></div>
      <img
        className="h-11 w-[247px] relative z-10"
        src="splash/logo.svg"
        alt="Don logo"
      />
      {restart ? (
        <button
          type="button"
          className="py-3 w-[183px] rounded-xl bg-white/08 text-sm font-semibold flex items-center justify-center gap-1 text-white"
          onClick={reloadApp}
        >
          <ReloadIcon className="size-5 text-white" />
          {t("reload")}
        </button>
      ) : (
        <div className="spinner"></div>
      )}

      <style jsx>
        {`
          .spinner {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            position: relative;
            animation: rotate 1s linear infinite;
          }
          .spinner::before {
            content: "";
            box-sizing: border-box;
            position: absolute;
            inset: 0px;
            border-radius: 50%;
            border: 3px solid #fbc76c;
            animation: prixClipFix 2s linear infinite;
          }

          @keyframes rotate {
            100% {
              transform: rotate(360deg);
            }
          }

          @keyframes prixClipFix {
            0% {
              clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
            }
            25% {
              clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
            }
            50% {
              clip-path: polygon(
                50% 50%,
                0 0,
                100% 0,
                100% 100%,
                100% 100%,
                100% 100%
              );
            }
            75% {
              clip-path: polygon(
                50% 50%,
                0 0,
                100% 0,
                100% 100%,
                0 100%,
                0 100%
              );
            }
            100% {
              clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);
            }
          }
        `}
      </style>
      {/* First video */}
      {/*<video*/}
      {/*    ref={videoRef1}*/}
      {/*    src="splash/first.webm"*/}
      {/*    className={`w-2/3 absolute bottom-0 left-0`}*/}
      {/*    autoPlay*/}
      {/*    muted*/}
      {/*/>*/}
      {/* Second looping video */}
      {/*<img*/}
      {/*    ref={videoRef2}*/}
      {/*    src="splash/output.gif"*/}
      {/*    className={`w-2/3 absolute bottom-0 left-0 z-0`}*/}
      {/*    loop*/}
      {/*    muted*/}
      {/*    autoPlay*/}
      {/*/>*/}
    </div>
  );
};

export default SplashScreen;
